export enum SupplierRiskManagementServiceType {
  Driven = 1,
  Transported = 2,
  Recovery = 3,
}
